  <div class="container-fluid pt-4">
    <div>
      <div class="row">
        <div class="col-xl-5 col-lg-12 col-md-12 col-sm-12 ">
          <div class="card flex-fill p-0 " id="card-state">
            <div class="card-header">
              <div class="card-actions float-end w-50 d-flex card-actions-state">
                <!-- <div class="col-10 d-flex flex-column align-items-end">
                  <span *ngIf="deviceConnected">{{"connected" | translate}} <i class="fas fa-circle text-primary fa-fw"></i></span>
                  <small>Last report: {{lastReport | date : 'short'}}</small>
                </div> -->
                <!-- <div class="col-2  text-end">
                  <i class="fas fa-expand ms-2" (click)="expand('state')"></i>
                </div> -->
              </div>
              <h5 class="card-title mb-0">{{"energyFlow" | translate}}</h5>
            </div>
            <div class="card-body mh-300" *ngIf="loading">
              <div class="d-flex justify-content-center align-items-center h-100 mh-300">
                <div class="spinner-grow text-primary" style="width: 4rem; height: 4rem;" role="status">
                  <span class="visually-hidden">{{"loading" | translate}}...</span>
                </div>
              </div>
            </div>
            <div class="card-body px-4 mh-300 d-flex justify-content-center align-items-center"
            *ngIf="!loading && errors.state">
            <h3>{{"noDataAvailable" | translate}}</h3>
          </div>
          <div class="card-body pb-3 pt-0" *ngIf="!loading && !errors.state" >
            <div class="row h-100">
              <!-- Gráfico de anillos  -->
              <div class="col-12 d-flex align-items-center justify-content-center order-1 order-lg-1"
              style="min-height: 323px;">
              <div class="container-rings-device d-flex align-items-center justify-content-center"
              id="container-circles" #containerCircles
              style="width: 100%; height: 100%; position: relative;">

              <div class="loading-container" *ngIf="loadingCircle"
              style="position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%); z-index: 10;">
              <div class="spinner-border text-primary" role="status" style="width: 3rem; height: 3rem;">
                <span class="visually-hidden">Loading...</span>
              </div>
              <!-- <div class="loading-text">
                <span>Cargando diagrama...</span>
              </div> -->
            </div>

            <div *ngIf="!loadingCircle" class="centered-content"
            style="position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%); width: 100%; height: 100%;">
            <ng-container *ngFor="let conn of connections">
              <ng-container *ngIf="getCircle(conn.from) && getCircle(conn.to)">
                <app-energy-flow-line
                [x1]="getCircle(conn.from).x"
                [y1]="getCircle(conn.from).y"
                [x2]="getCircle(conn.to).x"
                [y2]="getCircle(conn.to).y"
                [radius]="getCircle(conn.from).radius"
                [radiusPoint]="12"
                [colorScale]="getCircle(conn.to).colorScale"
                [invert]="conn.invert"
                [flowLines]="flowLines"
                ></app-energy-flow-line>
              </ng-container>
            </ng-container>

            <div *ngFor="let circle of circlePositions">
              <app-power-circle
              [value]="circle.value"
              [limit]="maxPower"
              [radius]="circle.radius"
              [x]="circle.x"
              [y]="circle.y"
              [colorScale]="circle.colorScale"
              [label]="circle.title"
              [icon]="circle.title === 'centro' ? circle.icon : undefined"
              ></app-power-circle>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
</div>
<div class="col-xl-7 col-lg-12 col-md-12 col-sm-12">
  <div class="row">
    <div class="col-12 col-sm-4 mb-3 mb-sm-0">
      <div class="card" style="min-height: 107px;">
        <div class="card-body">
          <div class="text-center">
            <h6 class="text-muted mb-1">{{"homePower" | translate}}</h6>
            <h4 class="text-primary mb-0">{{(infoModulator.stat.homePower / 1000) | number:'1.1-2'}} kW</h4>
          </div>
        </div>
      </div>
    </div>
    <div class="col-12 col-sm-4 mb-3 mb-sm-0">
      <div class="card" style="min-height: 107px;">
        <div class="card-body">
          <div class="text-center">
            <h6 class="text-muted mb-1">{{"chargerPower" | translate}}</h6>
            <h4 class="text-primary mb-0">{{(infoModulator.stat.evsePower / 1000) | number:'1.1-2'}} kW</h4>
          </div>
        </div>
      </div>
    </div>
    <div class="col-12 col-sm-4">
      <div class="card" style="min-height: 107px;">
        <div class="card-body">
          <div class="text-center">
            <h6 class="text-muted mb-1">{{"hiredPower" | translate}}</h6>
            <h4 class="text-primary mb-0">{{(infoModulator.stat.limitPower / 1000) | number:'1.1-2'}} kW</h4>
            <small class="text-warning d-block mt-1"> {{'stretchLimit' | translate}}: {{(maxPower / 1000) | number:'1.1-2'}} kW</small>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Conectores -->
  <div class="row">
    <div class="col-12">
      <div class="card">
        <div class="card-body">
          <!-- Conectores con layout adaptativo -->
          <div class="connectors-info">
            <h6 class="text-muted mb-3 text-center text-lg-start">{{"connectors" | translate}}</h6>
            <div class="row justify-content-center p-2">
              <div [ngClass]="{
                'col-8 col-lg-8 col-md-12': connectors.length === 1,
                'col-12 col-xxl-6 col-xl-12 col-lg-6 col-sm-6 col-xs-12': connectors.length === 2
                }" class="mb-3" *ngFor="let connector of connectors; let i = index">
                      <div class="sm-card d-flex row align-items-center mx-1" *ngIf="!loadingCircle">
                        <div class="col-12 d-flex align-items-center justify-content-between mb-2">
                          <div class="flex-grow-1">
                            <h6 class="text-primary mb-1 small">
                              {{connector.name.startsWith('mennekes') ? ("type" | translate)+'-2' : connector.name | titlecase}}
                            </h6>
                            <span class="badge badge-{{allStates[connectorsState[connector.name]?.state]?.icon}} text-white small badge-pill">
                              {{connectorsState[connector.name]?.state}} -
                              {{getTranslatedText(allStates[connectorsState[connector.name]?.state]?.text)}}
                            </span>
                          </div>

                          <div class="pe-2 justify-content-center d-flex align-items-center text-warning fs-4 px-4 m-auto"  >

                            <span
                              *ngIf="limitsCfg(connector, i)"
                              class="material-symbols-filled px-1 "
                              style="cursor: pointer;"
                              [ngbPopover]="limitPopoverTemplate"
                              triggers="click"
                              placement="top"
                              container="body"
                              (click)="selectedLimitText = limitsCfgText(connector, i)"
                            >{{ limitsCfg(connector, i) }}</span>

                            <span
                              *ngIf="limitIcon[i]"
                              class="material-symbols-filled px-1"
                              style="cursor: pointer;"
                              [ngbPopover]="limitPopoverTemplate"
                              triggers="click"
                              placement="top"
                              container="body"
                              (click)="selectedLimitText = limitText[i]"
                            >{{ limitIcon[i] }}</span>
                            <span
                              *ngIf="rfidLimit[i]"
                              class="px-1 text-danger d-inline-block"
                              style="width: 30px; height: 30px; cursor: pointer; background-color: currentColor; -webkit-mask: url('assets/img/orbis/rfid.svg') no-repeat center / contain; mask: url('assets/img/orbis/rfid.svg') no-repeat center / contain;"
                              role="img"
                              aria-label="RFID"
                              [ngbPopover]="limitPopoverTemplate"
                              triggers="click"
                              placement="top"
                              container="body"
                              (click)="selectedLimitText = rfidLimitText"
                            ></span>

                          </div>

                          <!-- Botones booster compactos -->
                          <div class="me-4 "
                          *ngIf="version7_2_0 && isBoosterActivable(connectorsState[connector.name]?.state) && (maxPower<infoModulator?.stat?.limitPower || connector.booster)">
                          <div class="d-flex button-group-container">
                            <div class="btn button-group d-flex align-items-center justify-content-center"
                            (click)="setBoost(false, connector.name)"
                            [ngClass]="{'btn-primary' : !connector.booster, 'btn-outline-primary' : connector.booster}"
                            style="border-radius: 8px 0px 0px 8px; padding: 8px 12px;">
                            <i class="fas fa-clock fa-xs"></i>
                          </div>
                          <div class="btn button-group d-flex align-items-center justify-content-center"
                          (click)="setBoost(true, connector.name)"
                          [ngClass]="{'btn-primary' : connector.booster, 'btn-outline-primary' : !connector.booster}"
                          style="border-radius: 0px 8px 8px 0px; padding: 8px 12px;">
                          <i class="fas fa-bolt fa-xs"></i>
                        </div>
                      </div>
                    </div>

                    <!-- Switch compacto -->
                    <label class="switch-sm mb-0"
                    *ngIf="connectorsState[connector.name]?.permission!=-1 && connectorsState[connector.name]?.permission!=undefined">
                    <input type="checkbox" [(ngModel)]="connectorsState[connector.name].permission"
                    (change)="changeStateConnector(connector.name)">
                    <span class="slider round"></span>
                  </label>
                </div>
                <div class="divider mb-2" style="border-bottom: solid 1px #eaeaea;"></div>
                <div class="col-12 d-flex mt-3 mb-2 p-0">
                  <div class="col-4" style="display: flex; flex-direction: column; align-items: center;">
                    <h5 class="text-primary mb-0">
                      {{connectorsState[connector.name]?.power || 0}} kW
                    </h5>
                    <small class="text-muted">
                      {{"Potencia" | translate}}
                    </small>
                  </div>
                  <div class="col-4" style="display: flex; flex-direction: column; align-items: center;">
                    <h5 class="text-primary mb-0">
                      + {{connectorsState[connector.name]?.energy || 0}} kWh
                    </h5>
                    <small class="text-muted">
                      {{"Energía" | translate}}
                    </small>
                  </div>
                  <div class="col-4" style="display: flex; flex-direction: column; align-items: center;">
                    <h5 class="text-primary mb-0">
                      {{connectorsState[connector.name]?.current || 0}} / {{connectorsState[connector.name]?.pwm || 0}} A
                    </h5>
                    <small class="text-muted">
                      {{"Corriente" | translate}}
                    </small>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
</div>
</div>


</div>

<div class="row">
  <div class="col-xl-6 col-xxl-6">
    <div class="card flex-fill w-100">
      <div class="card-header">
        <div class="card-actions float-end">
          <i class="fas fa-expand ms-2" (click)="expand('analytics')"></i>
        </div>
        <h5 class="card-title mb-0">{{"consumptions" | translate}}</h5>
      </div>

      <div class="card-body mh-300" *ngIf="loadingConsumptions">
        <div class="d-flex justify-content-center align-items-center h-100 mh-300">
          <div class="spinner-grow text-primary" style="width: 4rem; height: 4rem;" role="status">
            <span class="visually-hidden">{{"loading" | translate }}...</span>
          </div>
        </div>
      </div>

      <div class="card-body py-3 h_300" *ngIf="!loadingConsumptions && !errors.consumptions">
        <div class="chart chart-sm">
          <canvas id="chart" class="w-100 h-100"></canvas>
        </div>
      </div>

      <div class="card-body px-4 mh-300 d-flex justify-content-center align-items-center"
      *ngIf="!loadingConsumptions && errors.consumptions">
      <h3>{{"noHistoricDay" | translate}}</h3>
    </div>
  </div>

  <!-- <div class="card flex-fill w-100">
    <div class="card-header">
      <h5 class="card-title mb-0">{{"heatMap" | translate}} </h5>
    </div>
    <div class="card-body mh-300" *ngIf="loadingHeatmap">
      <div class="d-flex justify-content-center align-items-center h-100">
        <div class="spinner-grow text-primary" style="width: 4rem; height: 4rem;" role="status">
          <span class="sr-only">{{"loading" | translate }}... </span>
        </div>
      </div>
    </div>
    <div class="card-body px-4 h_300" *ngIf="!loadingHeatmap && !errors.heatmap">
      <canvas id="heatmap" class="w-100 h-100"></canvas>
    </div>
    <div class="card-body px-4 mh-300 d-flex justify-content-center align-items-center"
    *ngIf="!loadingHeatmap && errors.heatmap">
    <h3>{{"noHistoricDay" | translate}}</h3>
  </div>
</div> -->
</div>

<div class="col-xl-6 col-xxl-6">
  <div class="card flex-fill w-100">

    <div class="card-header">
      <div class="card-actions float-end">
        <i class="fas fa-expand ms-2" (click)="expand('historic')"></i>
      </div>
      <h5 class="card-title mb-0">{{"historics" | translate}}</h5>
    </div>

    <div class="card-body mh-300" *ngIf="loadingConsumptions">
      <div class="d-flex justify-content-center align-items-center h-100 mh-300">
        <div class="spinner-grow text-primary" style="width: 4rem; height: 4rem;" role="status">
          <span class="visually-hidden">{{"loading" | translate }}...</span>
        </div>
      </div>
    </div>

    <div class="card-body py-3 h_600">
      <table *ngIf="dataHistoric?.length>0" class="table table-striped my-0">
        <thead>
          <tr>
            <th> {{"startDate" | translate}} </th>
            <!-- <th class="d-none d-xl-table-cell">{{"historicsStartTime" | translate}}</th> -->
            <th class="d-none d-md-table-cell">{{"historicsDuration" | translate}}</th>
            <th class="d-none d-md-table-cell">{{"historicsEnergy" | translate}}</th>
            <th class="d-none d-md-table-cell">{{"historicsStartSource" | translate}}</th>
            <th class="d-none d-md-table-cell">{{"cost" | translate}}</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let historic of (dataHistoric?.length < 16 ? dataHistoric : dataHistoric.slice(0,16))">
            <td>{{historic.start_datetime | date:'dd/MM/yyyy HH:mm' }} </td>
            <!-- <td class="d-none d-xl-table-cell">{{historic.start_datetime | date:'h:mm a'}}</td> -->
            <td class="d-none d-md-table-cell">{{subtractDates(historic.end_datetime, historic.start_datetime)}}
            </td>
            <td class="d-none d-md-table-cell">{{historic.end_energy-historic.start_energy | number: '1.0-0'}} Wh
            </td>
            <div *ngIf="historic.start_source; then thenHistSource else elseHistSource"></div>
            <ng-template #thenHistSource>
              <td class="d-none d-md-table-cell">{{historic.start_source}}<small *ngIf="historic.user!=''">
                ({{historic.user}})</small></td>
              </ng-template>
              <ng-template #elseHistSource>
                <td class="d-none d-md-table-cell">{{historic.user}}</td>
              </ng-template>
              <td class="d-none d-md-table-cell" >{{ price > 0 ? ((historic.end_energy-historic.start_energy) / 1000 * price  | number:'1.2-2' ) : '-' }} {{ price > 0 ? coin : '' }}</td>
            </tr>
          </tbody>
        </table>
      </div>

      <div class="card-body px-4 mh-300 d-flex justify-content-center align-items-center"
      *ngIf="!loadingConsumptions && dataHistoric?.length<=0">
      <h3>{{"noHistoricDay" | translate}}</h3>
    </div>

  </div>
</div>
</div>
</div>

<button type="button" id="button-modal-activate" class="btn btn-primary d-none" data-bs-toggle="modal"
data-bs-target="#centeredModalPrimary">
Primary
</button>

<div class="modal" id="centeredModalPrimary" tabindex="-1" role="dialog" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered modal-card-devices m-auto" role="document">
    <div class="w-100 h-100">
      <div class="modal-content" [@zoomIn]="zoomIn" *ngIf="showModal">
        <div class="text-end p-1" style="background: transparent !important; border-bottom: none;">
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" (click)="resetModals()">
            <span class="text-white" style="font-size: 35px;" aria-hidden="true">&times;</span>
          </button>
        </div>

        <app-card-state [infoModulator]="infoModulator" [connectors]="connectors" [connectorsState]="connectorsState"
        *ngIf="expandBool.state"></app-card-state>
        <app-card-analytics [dataAnalytics]="dataAnalytics" [connectors]="connectors" [price]="price" [serial]="device" [coin]="coin"
        *ngIf="expandBool.analytics"></app-card-analytics>
        <app-card-historic [dataHistoric]="dataHistoric" [connectors]="connectors" [price]="price"
        *ngIf="expandBool.historic"></app-card-historic>
      </div>
    </div>
  </div>
</div>

<ng-template #limitPopoverTemplate let-popover  >
  <div class="d-flex justify-content-between align-items-center  bg-primary text-white p-2">
    <span class="text-white"> {{ "loading_limited" | translate }}</span>
    <button type="button" class="btn-close btn-close-white"  (click)="popover.close()"></button>
  </div>
  <div class="mt-3 ps-1">{{ selectedLimitText }}</div>
</ng-template>



